// src/App.js
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import MainLayout from './components/layout/MainLayout';
import MonCompteLayout from './components/layout/MonCompteLayout';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import RealisationsPage from './pages/RealisationsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import TarifsPage from './pages/TarifsPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import NotFoundPage from './pages/NotFoundPage';
import OnboardingWizard from './pages/OnboardingWizard';
import ConnexionPage from './pages/ConnexionPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PolitiqueConfidentialitePage from './pages/PolitiqueConfidentialitePage';
import BlogPage from './pages/BlogPage';
import ArticlePage from './pages/ArticlePage';
import CGVPage from './pages/CGVPage';
import GamesPage from './pages/GamesPage'; // <<< NOUVEL IMPORT POUR LA PAGE DE JEUX
import AdminPage from './pages/AdminPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import DevisPage from './pages/espace-client/DevisPage';
import FacturesPage from './pages/espace-client/FacturesPage';
import MesDocumentsPage from './pages/espace-client/MesDocumentsPage';
import SignatureContratPage from './pages/espace-client/SignatureContratPage';
import AdminProjectsPage from './pages/admin/AdminProjectsPage';
import AdminMessagesPage from './pages/admin/AdminMessagesPage';
import AdminMeetingsPage from './pages/admin/billing/AdminMeetingsPage';
import AdminTasksPage from './pages/admin/AdminTasksPage';
import AdminBillingHome from './pages/admin/billing/AdminBillingHome';
import AdminBillingQuotesPage from './pages/admin/billing/AdminBillingQuotesPage';
import AdminBillingInvoicesPage from './pages/admin/billing/AdminBillingInvoicesPage';
import AdminBillingContractsPage from './pages/admin/billing/AdminBillingContractsPage';
import AdminBillingCustomersPage from './pages/admin/billing/AdminBillingCustomersPage';
import AdminBillingProductsPage from './pages/admin/billing/AdminBillingProductsPage';
import AdminBillingPaymentsPage from './pages/admin/billing/AdminBillingPaymentsPage';
import AdminBillingServicesPage from './pages/admin/billing/AdminBillingServicesPage';
import AdminBillingStockPage from './pages/admin/billing/AdminBillingStockPage';
import AdminBillingRendezVousPage from './pages/admin/billing/AdminBillingRendezVousPage';
import AdminBillingHistoriquePage from './pages/admin/billing/AdminBillingHistoriquePage';
import AdminBillingSettingsPage from './pages/admin/billing/AdminBillingSettingsPage';
import AdminSiteHome from './pages/admin/site/AdminSiteHome';
import AdminSiteHomeSliderPage from './pages/admin/site/AdminSiteHomeSliderPage';
import AdminSiteHomeSectionsPage from './pages/admin/site/AdminSiteHomeSectionsPage';
import AdminSiteRealisationsCategoriesPage from './pages/admin/site/AdminSiteRealisationsCategoriesPage';
import AdminSiteRealisationsPage from './pages/admin/site/AdminSiteRealisationsPage';
import AdminSitePricingHome from './pages/admin/site/AdminSitePricingHome';
import AdminSitePricingPlansPage from './pages/admin/site/AdminSitePricingPlansPage';
import AdminSitePricingOptionsPage from './pages/admin/site/AdminSitePricingOptionsPage';
import AdminSitePricingComparisonPage from './pages/admin/site/AdminSitePricingComparisonPage';
import AdminSitePricingDetailsPage from './pages/admin/site/AdminSitePricingDetailsPage';
import AdminSiteContactHome from './pages/admin/site/AdminSiteContactHome';
import AdminSiteContactSettingsPage from './pages/admin/site/AdminSiteContactSettingsPage';
import AdminSiteContactMessagesPage from './pages/admin/site/AdminSiteContactMessagesPage';
import AdminSiteAnnouncementsPage from './pages/admin/site/AdminSiteAnnouncementsPage';
import AdminSiteEffectsPage from './pages/admin/site/AdminSiteEffectsPage';
import AdminSiteTaglinesPage from './pages/admin/site/AdminSiteTaglinesPage';
import AdminSiteBlogPostsPage from './pages/admin/site/AdminSiteBlogPostsPage';
import AdminSiteBlogCategoriesPage from './pages/admin/site/AdminSiteBlogCategoriesPage';
import AdminSalesTeamPage from './pages/admin/AdminSalesTeamPage';
import AdminStaffPage from './pages/admin/AdminStaffPage';
import AdminSiteTeamPage from './pages/admin/site/AdminSiteTeamPage';
import CommercialProfilePage from './pages/commercial/CommercialProfilePage';
import CommercialFormationPage from './pages/commercial/CommercialFormationPage';
import CommercialAdminPage from './pages/commercial/CommercialAdminPage';
import CommercialDashboardPage from './pages/commercial/CommercialDashboardPage';
import CommercialDealsPage from './pages/commercial/CommercialDealsPage';
import CommercialClientsPage from './pages/commercial/CommercialClientsPage';
import CommercialQuotesPage from './pages/commercial/CommercialQuotesPage';
import CommercialInvoicesPage from './pages/commercial/CommercialInvoicesPage';
import CommercialMeetingsPage from './pages/commercial/CommercialMeetingsPage';
import CommercialTasksPage from './pages/commercial/CommercialTasksPage';
import CommercialResourcesPage from './pages/commercial/CommercialResourcesPage';
import CommercialCommissionsPage from './pages/commercial/CommercialCommissionsPage';
import CommercialTemplatesPage from './pages/commercial/CommercialTemplatesPage';
import CommercialMapPage from './pages/commercial/CommercialMapPage';
import CommercialChallengesPage from './pages/commercial/CommercialChallengesPage';
import CommercialFunnelPage from './pages/commercial/CommercialFunnelPage';
import CommercialExportPage from './pages/commercial/CommercialExportPage';
import CommercialPhoningPage from './pages/commercial/CommercialPhoningPage';
import CommercialDealRoomPage from './pages/commercial/CommercialDealRoomPage';
import ClientRoomPage from './pages/commercial/ClientRoomPage';
import CommercialBattlecardsPage from './pages/commercial/CommercialBattlecardsPage';
import CommercialAnalyticsPage from './pages/commercial/CommercialAnalyticsPage';
import CommercialAvailabilityPage from './pages/commercial/CommercialAvailabilityPage';
import PublicBookingPage from './pages/commercial/PublicBookingPage';
import CommercialLeaderboardPage from './pages/commercial/CommercialLeaderboardPage';
import CommercialConfiguratorPage from './pages/commercial/CommercialConfiguratorPage';
import CommercialLaunchpadPage from './pages/commercial/CommercialLaunchpadPage';
import CommercialAgendaPage from './pages/commercial/CommercialAgendaPage';
import CommercialDemoPage from './pages/commercial/CommercialDemoPage';
import CommercialMoodboardPage from './pages/commercial/CommercialMoodboardPage';
import CommercialDiagnosticPage from './pages/commercial/CommercialDiagnosticPage';
import CommercialSignPage from './pages/commercial/CommercialSignPage';
import CommercialRoadmapPage from './pages/commercial/CommercialRoadmapPage';
import CommercialVideoMatonPage from './pages/commercial/CommercialVideoMatonPage';
import CommercialWheelPage from './pages/commercial/CommercialWheelPage';
import CommercialCashMachinePage from './pages/commercial/CommercialCashMachinePage';
import CommercialSpyPage from './pages/commercial/CommercialSpyPage';
import CommercialBuzzPage from './pages/commercial/CommercialBuzzPage';
import CommercialReferralPage from './pages/commercial/CommercialReferralPage';
import CommercialStudioPage from './pages/commercial/CommercialStudioPage';
import CommercialDomainHunterPage from './pages/commercial/CommercialDomainHunterPage';
import CommercialTrendsPage from './pages/commercial/CommercialTrendsPage';
import CommercialProductionPage from './pages/commercial/CommercialProductionPage';
import CommercialGreenLightPage from './pages/commercial/CommercialGreenLightPage';
import CommercialArchitectPage from './pages/commercial/CommercialArchitectPage';
import CommercialBriefPage from './pages/commercial/CommercialBriefPage';
import CommercialIceBreakerPage from './pages/commercial/CommercialIceBreakerPage';
import CommercialVisionPage from './pages/commercial/CommercialVisionPage';
import CommercialSpeedPage from './pages/commercial/CommercialSpeedPage';
import CommercialBundlesPage from './pages/commercial/CommercialBundlesPage';
import CommercialNightWorkerPage from './pages/commercial/CommercialNightWorkerPage';
import CommercialSecurityPage from './pages/commercial/CommercialSecurityPage';
import CommercialZenPage from './pages/commercial/CommercialZenPage';
import CommercialClubPage from './pages/commercial/CommercialClubPage';
import CommercialTimeMasterPage from './pages/commercial/CommercialTimeMasterPage';
import CommercialMemoPage from './pages/commercial/CommercialMemoPage';
import CommercialSorterPage from './pages/commercial/CommercialSorterPage';
import CommercialEchoPage from './pages/commercial/CommercialEchoPage';
import CommercialPlaceholderPage from './pages/commercial/CommercialPlaceholderPage';
import ScrollToTop from './components/utils/ScrollToTop';
import FloatingActionButtons from './components/common/FloatingActionButtons';
import CookieConsentBanner from './components/layout/CookieConsentBanner';
import AnalyticsTracker from './components/common/AnalyticsTracker/AnalyticsTracker';
import StaffOnboardingWizard from './pages/StaffOnboardingWizard';
import { AdminDataProvider } from './contexts/AdminDataContext';



import CommercialPresentationPage from './pages/commercial/CommercialPresentationPage'; // Newly created page

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isOnboarding = location.pathname.startsWith('/inscription') || location.pathname.startsWith('/candidature');
  const isMonCompte = location.pathname.startsWith('/mon-compte');
  const isCommercial = location.pathname.startsWith('/commercial');
  return (
    <AdminDataProvider>
      <ScrollToTop />
      <AnalyticsTracker />
      <Routes>
        {/* PUBLIC: routes sous MainLayout (header/footer du site) */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/realisations" element={<RealisationsPage />} />
          <Route path="/realisations/:projectSlug" element={<ProjectDetailPage />} />
          <Route path="/tarifs" element={<TarifsPage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          {/* Blog */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/tag/:tagSlug" element={<BlogPage />} />
          <Route path="/blog/:articleSlug" element={<ArticlePage />} />
          {/* Contact & Page cachée */}
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          {/* Connexion */}
          <Route path="/connexion" element={<ConnexionPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/jeux-secrets-info-colab" element={<GamesPage />} />
          <Route path="/cgv" element={<CGVPage />} />
          {/* Espace client: sous MainLayout (header/footer site) */}
          <Route
            path="/mon-compte"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route path="/mon-compte/profil" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/projets" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/projets" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/devis" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/factures" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/rendez-vous" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/historique" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/messages" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/contrats" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/contact" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/mon-compte/coffre-fort" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          {/* Sous-onglets rendus via hash dans le DashboardPage */}
          <Route path="/signature/:id" element={<SignatureContratPage />} />
          {/* 404 publique */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        {/* Onboarding: routes sans MainLayout (header/footer public retirés) */}
        <Route path="/inscription" element={<OnboardingWizard />} />
        <Route path="/candidature" element={<StaffOnboardingWizard />} />

        {/* ADMIN: routes sans MainLayout (header/footer public retirés) */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/messages"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminMessagesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/sales/team"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSalesTeamPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/staff"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminStaffPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/projects"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminProjectsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/meetings"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminMeetingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/tasks"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminTasksPage />
            </ProtectedRoute>
          }
        />
        {/* Facturation (FR) */}
        <Route
          path="/admin/facturation"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/devis"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingQuotesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/factures"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingInvoicesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/contrats"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingContractsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/clients"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingCustomersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/produits"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingProductsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/paiements"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingPaymentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/prestations"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingServicesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/stock"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingStockPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/rendez-vous"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingRendezVousPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/historique"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingHistoriquePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/facturation/parametres"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminBillingSettingsPage />
            </ProtectedRoute>
          }
        />

        {/* Site (CMS) */}
        <Route
          path="/admin/site"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site/accueil/slider"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteHomeSliderPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site/accueil/sections"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteHomeSectionsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/site/realisations/categories"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteRealisationsCategoriesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site/realisations"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteRealisationsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/site/tarifs"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSitePricingHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site/tarifs/plans"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSitePricingPlansPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site/tarifs/options"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSitePricingOptionsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/site/tarifs/comparatif"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSitePricingComparisonPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/site/tarifs/details"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSitePricingDetailsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/site/contact"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteContactHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site/contact/reglages"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteContactSettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site/contact/messages"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteContactMessagesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/site/annonces"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteAnnouncementsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/site/effets"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteEffectsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/site/taglines"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteTaglinesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/site/blog/articles"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteBlogPostsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site/blog/categories"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteBlogCategoriesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site/equipe"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSiteTeamPage />
            </ProtectedRoute>
          }
        />
        {/* COMMERCIAL: routes pour les commerciaux */}
        <Route
          path="/commercial/profile"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/formation"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialFormationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/admin"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/deals"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialDealsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/clients"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialClientsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/devis"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialQuotesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/factures"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialInvoicesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/meetings"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialMeetingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/tasks"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialTasksPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/resources"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialResourcesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/commissions"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialCommissionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/templates"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialTemplatesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/map"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialMapPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/challenges"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialChallengesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/funnel"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialFunnelPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/export"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialExportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/phoning"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialPhoningPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/deal-rooms"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialDealRoomPage />
            </ProtectedRoute>
          }
        />
        {/* Public Deal Room Route - No Auth Required (handled inside via token usually, here open ID) */}
        <Route path="/room/:dealId" element={<ClientRoomPage />} />

        {/* Public Booking Route */}
        <Route path="/booking/:userId" element={<PublicBookingPage />} />

        <Route
          path="/commercial/battlecards"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialBattlecardsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/analytics"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialAnalyticsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/availability"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialAvailabilityPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/leaderboard"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialLeaderboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/configurator"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialConfiguratorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/launchpad"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialLaunchpadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/launchpad/agenda"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialAgendaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/presentation"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialPresentationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/demo"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialDemoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/moodboard"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialMoodboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/diagnostic"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialDiagnosticPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/sign"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialSignPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/roadmap"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialRoadmapPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/video"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialVideoMatonPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/battlecards"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialBattlecardsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/wheel"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialWheelPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/cash-machine"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialCashMachinePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/spy"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialSpyPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/buzz"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialBuzzPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/referral"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialReferralPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/studio"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialStudioPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/domain"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialDomainHunterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/trends"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialTrendsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/production"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialProductionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/green-light"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialGreenLightPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/architect"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialArchitectPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/brief"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialBriefPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/icebreaker"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialIceBreakerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/vision"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialVisionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/speed"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialSpeedPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/bundles"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialBundlesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/night-worker"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialNightWorkerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/security"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialSecurityPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/zen"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialZenPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/club"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialClubPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/time-master"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialTimeMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/memo"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialMemoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/sorter"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialSorterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/commercial/echo"
          element={
            <ProtectedRoute requireCommercial={true}>
              <CommercialEchoPage />
            </ProtectedRoute>
          }
        />
      </Routes>

      {/* Boutons flottants et cookies uniquement pour le site public (pas sur admin, onboarding) */}
      {!isAdminRoute && !isOnboarding && !isCommercial && !isMonCompte && <FloatingActionButtons />}
      {!isAdminRoute && !isOnboarding && <CookieConsentBanner />}
    </AdminDataProvider>
  );
}

export default App;